import { Injectable } from "@angular/core";
import { AI_TEXTS, HAS_AI_AVAILABLE } from "src/app/interfaces/Global/Session";
import { IAIText } from "src/app/interfaces/Outputs/AIText";



@Injectable({
    providedIn: 'root'
})
export class AIDataService {
    setAITexts(ai_texts: IAIText) {
        localStorage.setItem(AI_TEXTS, JSON.stringify(ai_texts));
    }

    getAITexts(): IAIText | null {
        const aiTexts = localStorage.getItem(AI_TEXTS);
        return aiTexts ? JSON.parse(aiTexts) : null;
    }

    setHasAIAvailable(hasAI: boolean) {
        localStorage.setItem(HAS_AI_AVAILABLE, JSON.stringify(hasAI));
    }

    getHasAIAvailable(): boolean {
        try {
            return JSON.parse(localStorage.getItem(HAS_AI_AVAILABLE) ?? 'false') === true;
        } catch {
            return false;
        }
    }
}